import React, {useState} from 'react';
import {Camera, Vehicle, ViewMode} from '../types';
import CameraMisc from '../miscs/CameraMisc';
import CameraComponent from './CameraComponent';

type Props = {
  vehicle: Vehicle
  viewMode: ViewMode[],
  selected: Map<string, Camera>
}

const VehicleComponent = ( props: Props ) => {
  const [ collapsed, setCollapsed ] = useState( false );
  const camsToDisplay: Camera[] = [];
  const {viewMode, vehicle, selected} = props;
  if ( !collapsed ) {
    for ( let i = 0, len = vehicle.cams.length; i < len; i++ ) {
      const cam = vehicle.cams[i];
      if ( !viewMode.includes( ViewMode.active ) || !viewMode.includes( ViewMode.inactive ) ) {
        if ( !viewMode.includes( ViewMode.active ) && cam.isActive ) {
          continue;
        } else if ( !viewMode.includes( ViewMode.inactive ) && !cam.isActive ) {
          continue;
        }
      }
      camsToDisplay.push( cam );
    }
  }
  const isActive = CameraMisc.vehicleHasActiveCameras( vehicle );
  return (
    <div className='VehicleComponent'>
      <div className='VehicleComponent-inner no-selection' onClick={ () => {
        setCollapsed( !collapsed );
      } }>
        <i className={`icon icon-toggle ${collapsed === true && 'collapsed'}`} />
        <span title={vehicle.title} className='vehicle-title ellipsis'>{vehicle.title}</span>
        <i className={`icon icon-${isActive ? 'camera-white-sm' : 'camera-grey-sm'}`}/>
      </div>
      { camsToDisplay.map( (singleCam: Camera) => {
        const {vehicleId, id, channel} = singleCam;
        const key = `${vehicleId}-${id}-${channel}`;
        return <CameraComponent
          key={`cam${key}`}
          camera={ singleCam }
          isSelected={ selected.has( key ) }
        />;
      }) }
    </div>
  );
}

export default VehicleComponent;